import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	applicationInfo: null,
	loading: true,
	loadingSubmit: false
};

export default function applicationInfoPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_APPLICATION_INFO_REQUEST:
		case ActionTypes.GET_APPLICATION_INFO_ERROR:
		case ActionTypes.GET_APPLICATION_INFO_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_INFO_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_INFO_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_INFO_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_APPLICATION_INFO_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_APPLICATION_INFO_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
